import { useState } from "react";
import { dateToHumanFormat } from 'components/misc/constants';

function RepayDates({ dates }) {

    const show = 18;
    const [itemsToShow, setItemsToShow] = useState(show);
    const [expanded, setExpanded] = useState(false);

    const showMore = () => {
        setItemsToShow(expanded ? show : dates.length);
        setExpanded(!expanded);
    }

    return (
        <>
        {dates.slice(0, itemsToShow).map((date, index) => (
            <div key={index} className="rounded-lg px-3 py-2.5 bg-gray-50 dark:bg-white/[.04] ring-1 ring-inset ring-gray-200 dark:ring-white/[.06] flex items-center justify-center">
                <p className="text-xs font-medium text-gray-700 dark:text-white/[.7]">{dateToHumanFormat(date)}</p>
            </div>
        ))}

        {dates.length > show && (
            <div className="col-span-full">
                <div className="relative w-[95%] mx-auto flex py-1.5 items-center">
                    <div className="flex-grow border-t border-gray-100 dark:border-white/[.08]"></div>
                    <button type="button" className="flex-shrink mx-4 text-xs font-medium text-gray-500 hover:text-gray-700 dark:text-white/[.5] dark:hover:text-white/[.8]" onClick={showMore}>
                        {expanded ? "Show less dates" : "Show more dates"}
                    </button>
                    <div className="flex-grow border-t border-gray-100 dark:border-white/[.08]"></div>
                </div>
            </div>
        )}
        </>
    )
}

export default RepayDates